export enum AmbienteFiscal {
    PRODUCAO = 1,
    HOMOLOGACAO = 2,
}

export enum TipoEmpresa {
    Associacao = 'ASSOCIACAO',
    Individual = 'INDIVIDUAL',
    LTDA = 'LTDA',
    MEI = 'MEI',
}

export enum TipoCobranca {
    Pix = 'pix',
    Boleto = 'boleto',
    Bolepix = 'bolepix',
    PixCobranca = 'pix_cobranca',
    PixInstantaneo = 'pix_instantaneo',
}

export enum TipoConsulta {
    Detalhada = 'D',
    Resumida = 'R',
}

export enum IndicadorIe {
    NaoEspecificado = 0,
    Contribuinte = 1,
    Isento = 2,
    NaoContribuinte = 3,
}

export enum TipoPessoa {
    NaoEspecificado = '',
    Fisica = 'F',
    Juridica = 'J',
    Estrangeiro = 'E',
}

export enum EStatus {
    Ativo = 1,
    Inativo = 2,
}
